import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjSeismicS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.58333 4.09231C4.5 3.4359 2.55556 5.84274 1 6.71795L1 10C2.55556 8.90598 6.36667 6.84923 9.16667 7.37436C11.9667 7.89949 14.2222 6.71795 15 6.06154V2C13.8333 3.31282 10.8932 4.46363 8.58333 4.09231Z"
        fill="#FF4443"
      />
      <path
        d="M8.58333 10.028C6.25 10.028 3.54545 8.90909 1 10.3636L1 14C2.55556 12.8811 6.53107 10.8287 9.16667 12.042C12.0833 13.3846 14.2222 11.3706 15 10.6993V6C13.8333 7.34266 10.9167 10.028 8.58333 10.028Z"
        fill="#56B9F2"
      />
    </svg>
  )
}

export const IconGeoObjSeismic = createIcon({
  l: IconGeoObjSeismicS,
  m: IconGeoObjSeismicS,
  s: IconGeoObjSeismicS,
  xs: IconGeoObjSeismicS,
  name: 'IconGeoObjSeismic',
})
